const IMPORT = ['imports/:id'];

export default IMPORT;
